import * as React from "react";
import { WidthColumnProps } from "./typings";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { Viewport, ViewSmall, ViewMedium, ViewLarge, ViewSizes } from "@shared-ui/viewport-context";
import { ExtendedTemplateComponent } from "src/stores/ExperienceTemplateStore/typings";

export const GridContainerColumnsContext = React.createContext<number | undefined>(undefined);

export const widthVariableViewport = {
  [ViewSizes.SMALL]: "mobileWidth",
  [ViewSizes.MEDIUM]: "tabletWidth",
  [ViewSizes.LARGE]: "width",
};

const columnsForWidthMapping: WidthColumnProps = {
  "25": 4,
  "33": 3,
  "50": 2,
  "66": 3,
  "75": 4,
  "100": 1,
};

export const GridContainer: React.FC<{ templateComponent: ExtendedTemplateComponent }> = ({
  templateComponent,
  children,
}) => {
  const highestWidthViewport: Record<Exclude<ViewSizes, ViewSizes.EXTRA_LARGE>, string | undefined> = {
    [ViewSizes.SMALL]: undefined,
    [ViewSizes.MEDIUM]: undefined,
    [ViewSizes.LARGE]: undefined,
  };

  templateComponent.children?.forEach(({ config }) => {
    Object.keys(widthVariableViewport).forEach((viewPortWidth: keyof typeof widthVariableViewport) => {
      const widthPercentage = config[widthVariableViewport[viewPortWidth]];
      const highestWidth = highestWidthViewport[viewPortWidth];
      if (widthPercentage && +widthPercentage < 100 && (!highestWidth || +widthPercentage < +highestWidth)) {
        highestWidthViewport[viewPortWidth] = widthPercentage;
      }
    });
  });

  const gridContainerContent = (viewSize: ViewSizes) => {
    const viewPortWidth: string | undefined = highestWidthViewport[viewSize];
    return (
      <>
        {!viewPortWidth ? (
          <>{children}</>
        ) : (
          <GridContainerColumnsContext.Provider value={columnsForWidthMapping[viewPortWidth]}>
            <UitkLayoutGrid className="GridContainer" columns={columnsForWidthMapping[viewPortWidth]}>
              {children}
            </UitkLayoutGrid>
          </GridContainerColumnsContext.Provider>
        )}
      </>
    );
  };

  return (
    <Viewport>
      <ViewLarge>{gridContainerContent(ViewSizes.LARGE)}</ViewLarge>
      <ViewMedium>{gridContainerContent(ViewSizes.MEDIUM)}</ViewMedium>
      <ViewSmall>{gridContainerContent(ViewSizes.SMALL)}</ViewSmall>
    </Viewport>
  );
};
